export enum TipoArchivoImportacion {
   Standard,
   Exportacion,
}
